import { Vue, Component, Prop } from "vue-property-decorator";
import { IApp } from "./App.vue";
import { IService } from "./service/Service";

declare module "vue/types/vue" {
    interface Vue {
        root: IApp;
        service: IService;
    }
}

Vue.mixin({
    computed: {
        root() { return this.$root; },
        service(): IService {
            return (this.root as any).baseService;
        },
    },
});


export { Vue, Component, Prop };
